import React, { useState, useEffect, useCallback, useMemo } from 'react';
import verificareToken from './VerificareToken';
import { DataGridPro, useGridApiRef, useGridApiContext, useGridSelector, gridPageCountSelector, gridRowCountSelector, gridFilteredTopLevelRowCountSelector, GridToolbarContainer, GridToolbarExportContainer, GridToolbarColumnsButton, GridToolbarDensitySelector, GridToolbarFilterButton, GridCsvExportMenuItem, roRO, getGridStringOperators } from '@mui/x-data-grid-pro';
import { LicenseInfo } from '@mui/x-license-pro';
import { Button, Tooltip, FormControl, InputLabel, Select, MenuItem, TextField, Typography, IconButton, Chip, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Dialog, DialogTitle, DialogContent, DialogActions, Divider, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PrintIcon from '@mui/icons-material/Print';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import NotificationAddIcon from '@mui/icons-material/NotificationAdd';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import TimelineIcon from '@mui/icons-material/Timeline';
import StarIcon from '@mui/icons-material/Star';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/system';
import Swal from 'sweetalert';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { format } from 'date-fns';
import { ro } from 'date-fns/locale';
import { ExportInExcel } from './ExportInExcel';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { callAddFont } from './fonts/DejaVuSans-normal';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import DateFilterComponent from './DateFilterComponent';
import DateRangeFilterComponent from './DateRangeFilterComponent';
import PageExpander from './PageExpander';
import GavelIcon from '@mui/icons-material/Gavel';
import EventNoteIcon from '@mui/icons-material/EventNote';

LicenseInfo.setLicenseKey('c3a5a1d9f60b480a65b2c0d133d555d5Tz0xMzAxNzUsRT0xODEyOTMxMTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=');

function RapoarteTermene() {
  const { token } = verificareToken();
  window.dispatchEvent(new Event('authChange'));

  // Expandare
  const [isWide, setIsWide] = useState(false);
  const handleToggle = (isWideState) => {
    setIsWide(isWideState);
  };

  // State-uri principale
  const [dosare, setDosare] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [nrTotal, setNrTotal] = useState(0);
  const [dosareFiltrate, setDosareFiltrate] = useState([]);
  const [sortModel, setSortModel] = useState([]);
  const [showHeader, setShowHeader] = useState(false);
  const [showConfidential, setShowConfidential] = useState(false);
  const [usercurentgrup, setUsercurentgrup] = useState('');
  const [usercurentnume, setUsercurentnume] = useState('');

  // Filtre
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [accesoriiFiltru, setAccesoriiFiltru] = useState('');
  const [monitorizatFiltru, setMonitorizatFiltru] = useState('');
  const [sincronizatFiltru, setSincronizatFiltru] = useState('');

  // Paginare
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 15 });

  // Modal detalii dosar
  const [selectedRow, setSelectedRow] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [expandedStadii, setExpandedStadii] = useState({});
  const [showTimeline, setShowTimeline] = useState(false);
  const [partiExpanded, setPartiExpanded] = useState(false);

  const handleRowClick = (params, event) => {
    if (event.target.type === 'checkbox') return;
    setSelectedRow(params.row);
    setOpenModal(true);
    setExpandedStadii({});
    setShowTimeline(false);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedRow(null);
    setExpandedStadii({});
    setShowTimeline(false);
  };

  // Navigare prev/next între dosare
  const handleNavigateDosar = (direction) => {
    if (!selectedRow) return;
    const currentIndex = dosare.findIndex(d => d.id === selectedRow.id);
    if (currentIndex === -1) return;
    const newIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;
    if (newIndex >= 0 && newIndex < dosare.length) {
      setSelectedRow(dosare[newIndex]);
      setExpandedStadii({});
      setShowTimeline(false);
      setPartiExpanded(false);
    }
  };

  // Copiere număr dosar
  const handleCopyNumarDosar = () => {
    if (!selectedRow) return;
    navigator.clipboard.writeText(selectedRow.numardosarfinal).then(() => {
      setSnackbarMessage(`Număr dosar "${selectedRow.numardosarfinal}" copiat`);
      setSnackbarOpen(true);
    });
  };

  // Toggle expandare stadiu
  const toggleStadiu = (stadiuId) => {
    setExpandedStadii(prev => ({ ...prev, [stadiuId]: !prev[stadiuId] }));
  };

  // Expand/collapse all
  const toggleAllStadii = (expand) => {
    if (!selectedRow?._stadii) return;
    const newState = {};
    selectedRow._stadii.forEach((s, idx) => { newState[s.id || idx] = expand; });
    setExpandedStadii(newState);
  };

  // Găsește termenul următor (cel mai apropiat în viitor)
  const getNextTermen = (stadii) => {
    if (!stadii) return null;
    const now = new Date();
    let closest = null;
    stadii.forEach(s => {
      (s.termene || []).forEach(t => {
        const d = new Date(t.dataTermen);
        if (d > now && (!closest || d < new Date(closest.dataTermen))) {
          closest = { ...t, stadiuNume: s.denumireStadiu, stadiuInstanta: s.instanta };
        }
      });
    });
    return closest;
  };

  // Colectează toate termenele pt timeline
  const getAllTermene = (stadii) => {
    if (!stadii) return [];
    const all = [];
    stadii.forEach(s => {
      (s.termene || []).forEach(t => {
        all.push({ ...t, stadiuNume: s.denumireStadiu, stadiuInstanta: s.instanta });
      });
    });
    return all.sort((a, b) => new Date(a.dataTermen) - new Date(b.dataTermen));
  };

  // Adăugare notificare rapidă
  const handleAdaugareNotificare = () => {
    if (!selectedRow) return;
    window.location.href = `editare-dosar/${selectedRow.idDosar}?tab=notificari`;
  };

  // Export PDF fișă dosar din modal
  const handleExportFisaDosar = () => {
    if (!selectedRow) return;
    const doc = new jsPDF({ orientation: 'portrait', format: 'a4' });
    callAddFont(doc);
    doc.setFont('DejaVuSans');

    let y = 20;
    doc.setFontSize(14);
    doc.setTextColor('#1976d2');
    doc.text(`Fișă dosar: ${selectedRow.numardosarfinal}`, 14, y);
    y += 12;

    doc.setFontSize(10);
    doc.setTextColor('#333');
    const info = [
      ['Client', selectedRow.client || '—'],
      ['Parte adversă', selectedRow.parteadversa || '—'],
      ['Instanță', selectedRow.deninstanta || '—'],
      ['Obiect dosar', selectedRow.denumireobiect || '—'],
      ['Materie', selectedRow.materie_obiect_dosar || '—'],
      ['Calitate client', selectedRow.calitateclientdosar || '—'],
      ['Stare dosar', selectedRow.staredosar || '—'],
      ['Utilizator', selectedRow.user_fullname || '—'],
    ];

    info.forEach(([label, value]) => {
      doc.setFont('DejaVuSans', 'normal');
      doc.setTextColor('#888');
      doc.text(label + ':', 14, y);
      doc.setTextColor('#333');
      doc.text(String(value), 60, y);
      y += 7;
    });

    if (selectedRow.parti_dosar) {
      y += 3;
      doc.setTextColor('#888');
      doc.text('Părți dosar:', 14, y);
      y += 6;
      doc.setTextColor('#333');
      const partiLines = doc.splitTextToSize(String(selectedRow.parti_dosar), 170);
      doc.text(partiLines, 14, y);
      y += partiLines.length * 5 + 4;
    }

    y += 5;
    doc.setFontSize(11);
    doc.setTextColor('#1976d2');
    doc.text(`Stadii și termene (${selectedRow.nrStadii} stadii, ${selectedRow.nrTermene} termene)`, 14, y);
    y += 8;

    if (selectedRow._stadii && selectedRow._stadii.length > 0) {
      selectedRow._stadii.forEach((stadiu) => {
        if (y > 260) { doc.addPage(); y = 20; }
        doc.setFontSize(10);
        doc.setTextColor('#1976d2');
        const stadiuText = `${stadiu.denumireStadiu} — ${stadiu.instanta}${stadiu.sectie ? ' (' + stadiu.sectie + ')' : ''}${stadiu.data ? '  din ' + formatDate(stadiu.data) : ''}`;
        doc.text(stadiuText, 14, y);
        y += 7;

        if (stadiu.termene && stadiu.termene.length > 0) {
          const termenHeaders = ['Dată termen', 'Complet', 'Tip soluție', 'Sumar soluție', 'Nr. doc', 'Dată doc'];
          const termenRows = stadiu.termene.map(t => [
            formatDateTime(t.dataTermen),
            t.complet || '—',
            t.tipsolutie || '—',
            (t.sumarsolutie || '—').substring(0, 60),
            t.numarDocument || '—',
            t.dataDocument && t.dataDocument !== '0000-00-00 00:00:00' ? formatDate(t.dataDocument) : '—',
          ]);

          doc.autoTable({
            head: [termenHeaders],
            body: termenRows,
            startY: y,
            theme: 'grid',
            styles: { font: 'DejaVuSans', fontSize: 8, cellPadding: 2, overflow: 'linebreak' },
            headStyles: { fillColor: [245, 245, 245], textColor: [51, 51, 51], fontStyle: 'bold' },
            margin: { left: 14, right: 14 },
          });
          y = doc.lastAutoTable.finalY + 8;
        } else {
          doc.setFontSize(9);
          doc.setTextColor('#999');
          doc.text('Fără termene', 20, y);
          y += 7;
        }
      });
    }

    doc.save(`Fisa dosar ${selectedRow.numardosarfinal.replace(/\//g, '-')} - ${formattedDate}.pdf`);
  };

  // Vizibilitate coloane
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    numardosarfinal: true,
    client: true,
    parteadversa: true,
    deninstanta: true,
    denumireobiect: true,
    materie_obiect_dosar: true,
    staredosar: true,
    calitateclientdosar: true,
    denumirestadiu: true,
    datatermen: true,
    complet: true,
    tipsolutie: true,
    sumarsolutie: true,
    user_fullname: true,
    nrStadii: true,
    nrTermene: true,
  });

  // Date curente pt export
  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString('ro-RO').replace(/\//g, '-');
  const formattedTime = currentDate.toLocaleTimeString('ro-RO', { hour12: false }).replace(/:/g, '-');
  const formattedTime2 = currentDate.toLocaleTimeString('ro-RO', { hour: '2-digit', minute: '2-digit', hour12: false });
  const fileNameExcel = `JuristPRO NEXT - Raport Termene - ${formattedDate} - ${formattedTime}`;
  const fileNameCSV = `JuristPro NEXT - CSV Raport Termene - ${formattedDate} - ${formattedTime}`;

  function getDenAppVers() {
    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    }
    let denAppVers = getCookie('DenAppVers');
    if (!denAppVers) denAppVers = localStorage.getItem('DenAppVers');
    if (!denAppVers) denAppVers = sessionStorage.getItem('DenAppVers');
    return denAppVers || 'V2';
  }
  let denAppVers = getDenAppVers();

  const apiRef2 = useGridApiRef();

  // Fetch user curent
  useEffect(() => {
    const fetchUsercurent = async () => {
      try {
        const response = await fetch(`${window.API_URL}user`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
        });
        const { data } = await response.json();
        setUsercurentgrup(data.user.groupNames);
        setUsercurentnume(data.user.fullname);
      } catch (error) {
        console.error("Eroare la preluarea utilizatorului curent", error);
      }
    };
    fetchUsercurent();
  }, [token]);

  // Fetch dosare cu termene
  const fetchData = useCallback(async () => {
    const { token } = verificareToken();
    setIsLoading(true);
    try {
      let url = `${window.API_URL}dosareCuTermene?`;
      const params = [];
      if (accesoriiFiltru !== '') params.push(`accesorii=${accesoriiFiltru}`);
      if (monitorizatFiltru !== '') params.push(`monitorizat=${monitorizatFiltru}`);
      if (sincronizatFiltru !== '') params.push(`sincronizat=${sincronizatFiltru}`);
      if (startDate) params.push(`startDate=${format(startDate, 'yyyy-MM-dd')}`);
      if (endDate) params.push(`endDate=${format(endDate, 'yyyy-MM-dd')}`);
      url += params.join('&');

      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      });
      const data = await response.json();

      if (data && data.data && Array.isArray(data.data.dosare)) {
        setNrTotal(data.data.nrTotal || data.data.dosare.length);
        // Un singur rând per dosar - stadiul curent + primul termen ca date principale
        const rows = [];
        data.data.dosare.forEach((dosar) => {
          const stadii = dosar.stadii || [];
          const nrStadii = stadii.length;
          let nrTermeneTotal = 0;
          stadii.forEach(s => { nrTermeneTotal += (s.termene || []).length; });

          // Luăm primul stadiu și primul termen ca date principale afișate în tabel
          const primuStadiu = stadii.length > 0 ? stadii[0] : null;
          const primulTermen = primuStadiu && primuStadiu.termene && primuStadiu.termene.length > 0 ? primuStadiu.termene[0] : null;

          rows.push({
            id: dosar.id,
            idDosar: dosar.id,
            numardosarfinal: dosar.numardosarfinal,
            client: dosar.client,
            parteadversa: dosar.parteadversa || dosar.parti_adverse,
            deninstanta: primuStadiu ? (primuStadiu.instanta || dosar.deninstanta) : dosar.deninstanta,
            denumireobiect: dosar.denumireobiect,
            materie_obiect_dosar: dosar.materie_obiect_dosar,
            staredosar: dosar.staredosar,
            calitateclientdosar: dosar.calitateclientdosar,
            denumirestadiu: primuStadiu ? primuStadiu.denumireStadiu : '',
            datastadiu: primuStadiu ? primuStadiu.data : '',
            datatermen: primulTermen ? primulTermen.dataTermen : (dosar.datatermen || ''),
            complet: primulTermen ? primulTermen.complet : (dosar.complet || ''),
            tipsolutie: primulTermen ? primulTermen.tipsolutie : '',
            sumarsolutie: primulTermen ? primulTermen.sumarsolutie : '',
            dataDocument: primulTermen ? primulTermen.dataDocument : '',
            numarDocument: primulTermen ? primulTermen.numarDocument : '',
            user_fullname: dosar.user_fullname,
            nrStadii: nrStadii,
            nrTermene: nrTermeneTotal,
            parti_dosar: dosar.parti_dosar,
            sectie: primuStadiu ? primuStadiu.sectie : '',
            _stadii: stadii,
          });
        });
        setDosare(rows);
      } else {
        console.error('Format date incorect:', data);
        setDosare([]);
      }
    } catch (error) {
      console.error('Eroare la preluarea dosarelor cu termene:', error);
    } finally {
      setIsLoading(false);
    }
  }, [accesoriiFiltru, monitorizatFiltru, sincronizatFiltru, startDate, endDate]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Filtre diacritice
  const stringFilterOperators = getGridStringOperators();
  const removeDiacritics = (str) => {
    if (typeof str !== 'string') return str;
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const wrapFilterOperator = useCallback((operator) => {
    const getApplyFilterFn = (filterItem, column) => {
      const innerFilterFn = operator.getApplyFilterFn(
        { ...filterItem, value: removeDiacritics(filterItem.value) },
        column
      );
      if (!innerFilterFn) return innerFilterFn;
      return (params) => {
        const newParams = { ...params, value: removeDiacritics(params.value) };
        return innerFilterFn(newParams);
      };
    };
    return { ...operator, getApplyFilterFn };
  }, []);

  // Date filter operators
  const dateFilterOperators = useMemo(() => [
    {
      label: 'egal cu',
      value: 'contains',
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.value) return null;
        return (params) => {
          const dateFromRow = new Date(params.value).setHours(0, 0, 0, 0);
          const selectedDate = new Date(filterItem.value).setHours(0, 0, 0, 0);
          return dateFromRow === selectedDate;
        };
      },
      InputComponent: DateFilterComponent,
    },
    {
      label: 'înainte de',
      value: 'before',
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.value) return null;
        return (params) => {
          const dateFromRow = new Date(params.value).setHours(0, 0, 0, 0);
          const selectedDate = new Date(filterItem.value).setHours(0, 0, 0, 0);
          return dateFromRow < selectedDate;
        };
      },
      InputComponent: DateFilterComponent,
    },
    {
      label: 'după data',
      value: 'after',
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.value) return null;
        return (params) => {
          const dateFromRow = new Date(params.value).setHours(0, 0, 0, 0);
          const selectedDate = new Date(filterItem.value).setHours(0, 0, 0, 0);
          return dateFromRow > selectedDate;
        };
      },
      InputComponent: DateFilterComponent,
    },
    {
      label: 'între',
      value: 'between',
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.value || !filterItem.value[0] || !filterItem.value[1]) return null;
        return (params) => {
          const dateFromRow = new Date(params.value).setHours(0, 0, 0, 0);
          const startDate = new Date(filterItem.value[0]).setHours(0, 0, 0, 0);
          const endDate = new Date(filterItem.value[1]).setHours(0, 0, 0, 0);
          return dateFromRow >= startDate && dateFromRow <= endDate;
        };
      },
      InputComponent: DateRangeFilterComponent,
    },
  ], []);

  // Format date
  const formatDate = (date) => {
    if (!date || date === '0000-00-00 00:00:00') return '';
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const formatDateTime = (date) => {
    if (!date || date === '0000-00-00 00:00:00') return '';
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear();
    const hours = d.getHours().toString().padStart(2, '0');
    const minutes = d.getMinutes().toString().padStart(2, '0');
    return `${day}.${month}.${year} ${hours}:${minutes}`;
  };

  // Filter model
  const [filterModel, setFilterModel] = useState({ items: [] });
  const handleFilterModelChange = (newModel) => {
    setFilterModel({ ...newModel, items: newModel.items });
  };

  // Coloane
  const columns = useMemo(() => [
    {
      field: 'numardosarfinal',
      headerName: 'Număr dosar',
      width: 180,
      filterOperators: stringFilterOperators.map((op) => wrapFilterOperator(op)),
      renderCell: (params) => (
        <Tooltip title={`Deschide dosarul ${params.value}`}>
          <span
            style={{ cursor: 'pointer', color: '#1976d2', fontWeight: 500 }}
            onClick={() => window.location.href = `editare-dosar/${params.row.idDosar}`}
          >
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    { field: 'client', headerName: 'Client', width: 220, filterOperators: stringFilterOperators.map((op) => wrapFilterOperator(op)) },
    { field: 'parteadversa', headerName: 'Parte adversă', width: 220, filterOperators: stringFilterOperators.map((op) => wrapFilterOperator(op)) },
    { field: 'deninstanta', headerName: 'Instanță', width: 200, filterOperators: stringFilterOperators.map((op) => wrapFilterOperator(op)) },
    { field: 'denumireobiect', headerName: 'Obiect dosar', width: 180, filterOperators: stringFilterOperators.map((op) => wrapFilterOperator(op)) },
    { field: 'materie_obiect_dosar', headerName: 'Materie', width: 200, filterOperators: stringFilterOperators.map((op) => wrapFilterOperator(op)) },
    { field: 'staredosar', headerName: 'Stare dosar', width: 120, filterOperators: stringFilterOperators.map((op) => wrapFilterOperator(op)) },
    { field: 'calitateclientdosar', headerName: 'Calitate client', width: 140, filterOperators: stringFilterOperators.map((op) => wrapFilterOperator(op)) },
    { field: 'denumirestadiu', headerName: 'Stadiu', width: 130, filterOperators: stringFilterOperators.map((op) => wrapFilterOperator(op)),
      renderCell: (params) => (
        <span>
          {params.value && <><GavelIcon style={{ fontSize: 14, marginRight: 4, color: '#666' }} />{params.value}</>}
        </span>
      ),
    },
    {
      field: 'datatermen',
      headerName: 'Dată termen',
      width: 170,
      filterable: true,
      filterOperators: dateFilterOperators,
      valueFormatter: ({ value }) => formatDateTime(value),
      renderCell: (params) => {
        if (!params.value || params.value === '0000-00-00 00:00:00') return '';
        const d = new Date(params.value);
        const now = new Date();
        const isPast = d < now;
        return (
          <span style={{ color: isPast ? '#d32f2f' : '#2e7d32', fontWeight: 500 }}>
            <EventNoteIcon style={{ fontSize: 14, marginRight: 4 }} />
            {formatDateTime(params.value)}
          </span>
        );
      },
    },
    { field: 'complet', headerName: 'Complet', width: 180, filterOperators: stringFilterOperators.map((op) => wrapFilterOperator(op)) },
    { field: 'tipsolutie', headerName: 'Tip soluție', width: 160, filterOperators: stringFilterOperators.map((op) => wrapFilterOperator(op)) },
    {
      field: 'sumarsolutie',
      headerName: 'Sumar soluție',
      width: 300,
      filterOperators: stringFilterOperators.map((op) => wrapFilterOperator(op)),
      renderCell: (params) => (
        <Tooltip title={params.value || ''}>
          <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    { field: 'user_fullname', headerName: 'Utilizator', width: 150, filterOperators: stringFilterOperators.map((op) => wrapFilterOperator(op)) },
    { field: 'nrStadii', headerName: 'Nr. stadii', width: 100, type: 'number' },
    { field: 'nrTermene', headerName: 'Nr. termene', width: 110, type: 'number' },
    { field: 'parti_dosar', headerName: 'Părți dosar', width: 250, filterOperators: stringFilterOperators.map((op) => wrapFilterOperator(op)) },
    { field: 'sectie', headerName: 'Secție', width: 250, filterOperators: stringFilterOperators.map((op) => wrapFilterOperator(op)) },
    {
      field: 'datastadiu',
      headerName: 'Dată stadiu',
      width: 130,
      filterable: true,
      filterOperators: dateFilterOperators,
      valueFormatter: ({ value }) => formatDate(value),
    },
    {
      field: 'dataDocument',
      headerName: 'Dată document',
      width: 130,
      filterable: true,
      filterOperators: dateFilterOperators,
      valueFormatter: ({ value }) => formatDate(value),
    },
    { field: 'numarDocument', headerName: 'Număr document', width: 150, filterOperators: stringFilterOperators.map((op) => wrapFilterOperator(op)) },
  ], [stringFilterOperators, wrapFilterOperator, dateFilterOperators]);

  // Sortare
  const sortNumarDosar = (a, b) => {
    const numarA = parseInt(a.split('/')[0]);
    const numarB = parseInt(b.split('/')[0]);
    if (numarA < numarB) return -1;
    if (numarA > numarB) return 1;
    return 0;
  };

  const compareValues = (a, b, field, sortDirection) => {
    if (field === 'numardosarfinal') {
      const result = sortNumarDosar(a[field], b[field]);
      return sortDirection === 'asc' ? result : -result;
    }
    if (a[field] === undefined || a[field] === null) return sortDirection === 'asc' ? -1 : 1;
    if (b[field] === undefined || b[field] === null) return sortDirection === 'asc' ? 1 : -1;
    if (typeof a[field] === 'string') {
      return sortDirection === 'asc' ? a[field].localeCompare(b[field]) : b[field].localeCompare(a[field]);
    }
    if (typeof a[field] === 'number' || a[field] instanceof Date) {
      return sortDirection === 'asc' ? a[field] - b[field] : b[field] - a[field];
    }
    return 0;
  };

  const sortRows = (rows, sortModel) => {
    if (!sortModel.length) return rows;
    const { field, sort } = sortModel[0];
    return [...rows].sort((a, b) => compareValues(a, b, field, sort));
  };

  const handleSortModelChange = (sortModel) => {
    const sortedRows = sortRows(dosare, sortModel);
    setDosareFiltrate(sortedRows);
    setSortModel(sortModel);
  };

  // State change pt filtrare
  function getKeysFromLookup(obj) {
    const keys = [];
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && obj[key]) keys.push(key);
    }
    return keys;
  }

  const [filteredRowCount, setFilteredRowCount] = useState(null);

  const handleStateChange = useCallback(
    (state) => {
      const filteredKeys = getKeysFromLookup(state.filter.filteredRowsLookup);
      const rows = filteredKeys.map((key) => apiRef2.current.getRow(key));
      
      // Actualizăm numărul de rânduri filtrate
      const hasActiveFilter = state.filter.filterModel?.items?.some(item => item.value !== undefined && item.value !== '' && item.value !== null);
      setFilteredRowCount(hasActiveFilter ? filteredKeys.length : null);
      
      if (JSON.stringify(rows) !== JSON.stringify(dosareFiltrate)) {
        setDosareFiltrate(rows);
      }
    },
    [apiRef2, dosareFiltrate],
  );

  // dosareFinal - prioritate: selectate > filtrate > toate
  const [selectionModel, setSelectionModel] = useState([]);

  const getDosareFinal = useCallback(() => {
    // 1. Dacă sunt rânduri selectate (bifate), le folosim pe acelea
    if (apiRef2.current?.getSelectedRows) {
      const selectedMap = apiRef2.current.getSelectedRows();
      if (selectedMap.size > 0) {
        const sortedIds = apiRef2.current.getSortedRowIds();
        const selectedIds = new Set(selectedMap.keys());
        return sortedIds.filter(id => selectedIds.has(id)).map(id => apiRef2.current.getRow(id)).filter(Boolean);
      }
    }
    // 2. Dacă sunt rânduri filtrate, le folosim pe acelea (în ordinea sortată din grid)
    if (Array.isArray(dosareFiltrate) && dosareFiltrate.length > 0 && dosareFiltrate.length < dosare.length) {
      if (apiRef2.current?.getSortedRowIds) {
        const filteredIds = new Set(dosareFiltrate.map(fr => fr.id));
        return apiRef2.current.getSortedRowIds().map(id => apiRef2.current.getRow(id)).filter(row => row && filteredIds.has(row.id));
      }
      return dosareFiltrate;
    }
    // 3. Altfel, toate dosarele (în ordinea sortată din grid)
    if (apiRef2.current?.getSortedRowIds) {
      return apiRef2.current.getSortedRowIds().map(id => apiRef2.current.getRow(id)).filter(Boolean);
    }
    return dosare;
  }, [dosareFiltrate, dosare]);

  // Expandează fiecare dosar în câte un rând per termen (pentru export)
  const expandDosareToTermene = useCallback((dosareList) => {
    const rows = [];
    dosareList.forEach((dosar) => {
      const stadii = dosar._stadii || [];
      let hasTermene = false;
      stadii.forEach((stadiu) => {
        (stadiu.termene || []).forEach((termen) => {
          hasTermene = true;
          rows.push({
            ...dosar,
            denumirestadiu: stadiu.denumireStadiu || '',
            datastadiu: stadiu.data || '',
            deninstanta: stadiu.instanta || dosar.deninstanta,
            sectie: stadiu.sectie || '',
            datatermen: termen.dataTermen || '',
            complet: termen.complet || '',
            tipsolutie: termen.tipsolutie || '',
            sumarsolutie: termen.sumarsolutie || '',
            dataDocument: termen.dataDocument || '',
            numarDocument: termen.numarDocument || '',
          });
        });
      });
      // Dacă dosarul nu are termene deloc, îl includem oricum cu date goale
      if (!hasTermene) {
        rows.push({ ...dosar });
      }
    });
    return rows;
  }, []);

  // Export XML
  const handleExportXML = () => {
    const visibleColumns = columns.filter((col) => columnVisibilityModel[col.field] !== false);
    const dosareFinal = expandDosareToTermene(getDosareFinal());
    if (visibleColumns.length === 0 || dosareFinal.length === 0) return;

    let xmlContent = '<?xml version="1.0" encoding="UTF-8"?>\n<DosareCuTermene>\n';
    dosareFinal.forEach(row => {
      xmlContent += '  <Dosar>\n';
      visibleColumns.forEach(col => {
        const fieldName = col.headerName.replace(/\s+/g, '_');
        const cellValue = row[col.field] || '';
        xmlContent += `    <${fieldName}>${cellValue}</${fieldName}>\n`;
      });
      xmlContent += '  </Dosar>\n';
    });
    xmlContent += '</DosareCuTermene>';

    const blob = new Blob([xmlContent], { type: 'application/xml' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `export_dosare_termene_${formattedDate}.xml`;
    link.click();
  };

  // Export PDF
  const handleExportPDFComand = () => {
    setShowHeader(false);
    setShowConfidential(false);
    const dosareFinal = expandDosareToTermene(getDosareFinal());
    const text = `${dosareFinal.length} rânduri vor fi exportate în PDF`;

    const container = document.createElement('div');
    container.className = 'divswal';
    container.insertAdjacentHTML('beforeend', `
      <div class="switch-container">
        <label for="headerSwitch">Afișare antet</label>
        <label class="switch">
          <input type="checkbox" id="headerSwitch">
          <span class="slider round"></span>
        </label>
      </div>
      <div class="switch-container">
        <label for="confidentialSwitch">Afișare "Confidențial"</label>
        <label class="switch">
          <input type="checkbox" id="confidentialSwitch">
          <span class="slider round"></span>
        </label>
      </div>
    `);

    Swal({
      title: 'Export PDF tabel',
      text: text,
      content: container,
      icon: 'warning',
      buttons: ['Anulează', 'Da, continui!'],
      dangerMode: true,
    }).then((willContinue) => {
      if (willContinue) {
        const headerSwitch = document.getElementById('headerSwitch');
        const confidentialSwitch = document.getElementById('confidentialSwitch');
        handleExportPDF(headerSwitch.checked, confidentialSwitch.checked, dosareFinal);
      }
    });
  };

  const handleExportPDF = (showHeader1, showConfidential1, dosareFinal) => {
    if (!apiRef2.current) return;
    const orderedFields = apiRef2.current.state.columns.orderedFields;
    const visibleColumns = orderedFields
      .map(field => columns.find(col => col.field === field))
      .filter(col => col && columnVisibilityModel[col.field] !== false);

    if (visibleColumns.length === 0 || dosareFinal.length === 0) return;

    let pageFormat = 'a4';
    if (visibleColumns.length > 5 && visibleColumns.length <= 8) pageFormat = 'a3';
    else if (visibleColumns.length > 8 && visibleColumns.length <= 12) pageFormat = 'a2';
    else if (visibleColumns.length > 12 && visibleColumns.length <= 15) pageFormat = 'a1';
    else if (visibleColumns.length > 15) pageFormat = 'a0';

    const doc = new jsPDF({ orientation: 'landscape', format: pageFormat });
    callAddFont(doc);
    doc.setFont('DejaVuSans');

    let startY = 20;
    if (showHeader1) {
      doc.setFontSize(12);
      doc.setTextColor('#333');
      const grupuri = usercurentgrup.split(',');
      const grupuriText = grupuri.length > 1
        ? `pentru ${grupuri.length} unități (${usercurentgrup})`
        : `pentru unitatea ${usercurentgrup}`;
      doc.text(`Raport dosare cu termene generat la ${formattedDate} ora ${formattedTime2}, ${grupuriText}.`, 14, startY);
      if (startDate) {
        const sd = format(startDate, 'dd.MM.yyyy');
        const ed = endDate ? format(endDate, 'dd.MM.yyyy') : formattedDate;
        doc.text(`Perioada: ${sd} - ${ed} din JuristPRO NEXT ${denAppVers}.`, 14, startY + 10);
      } else {
        doc.text(`Exportul a fost realizat pentru toată perioada din JuristPRO NEXT ${denAppVers}.`, 14, startY + 10);
      }
      startY += 12;
    }

    if (showConfidential1) {
      doc.setFontSize(14);
      doc.setTextColor(255, 0, 0);
      doc.text(`CONFIDENTIAL utilizator ${usercurentnume}`, 14, startY + 10);
      startY += 10;
    }

    const tableColumnHeaders = visibleColumns.map(col => col.headerName);
    const tableRows = dosareFinal.map((row) =>
      visibleColumns.map((col) => {
        if (col.field === 'datatermen') return formatDateTime(row[col.field]);
        if (col.field === 'datastadiu' || col.field === 'dataDocument') return formatDate(row[col.field]);
        return row[col.field] || '';
      })
    );

    doc.autoTable({
      head: [tableColumnHeaders],
      body: tableRows,
      startY: startY + 10,
      theme: 'grid',
      styles: { font: 'DejaVuSans', fontSize: 10, cellPadding: 3, overflow: 'linebreak', cellWidth: 'auto' },
      tableWidth: 'auto',
      didDrawPage: (data) => {
        const pageCount = doc.internal.getNumberOfPages();
        doc.setFontSize(10);
        doc.text(`Pagina ${data.pageNumber} din ${pageCount}`, data.settings.margin.left, doc.internal.pageSize.height - 10);
      },
    });
    doc.save(`Raport Termene - PDF - ${formattedDate} - ${formattedTime}.pdf`);
  };

  // Print
  const handlePrintComand = () => {
    setShowHeader(false);
    setShowConfidential(false);
    const dosareFinal = expandDosareToTermene(getDosareFinal());
    const text = `${dosareFinal.length} rânduri vor fi imprimate`;

    const container = document.createElement('div');
    container.className = 'divswal';
    container.insertAdjacentHTML('beforeend', `
      <div class="switch-container">
        <label for="headerSwitch">Afișare antet</label>
        <label class="switch">
          <input type="checkbox" id="headerSwitch">
          <span class="slider round"></span>
        </label>
      </div>
      <div class="switch-container">
        <label for="confidentialSwitch">Afișare "Confidențial"</label>
        <label class="switch">
          <input type="checkbox" id="confidentialSwitch">
          <span class="slider round"></span>
        </label>
      </div>
    `);

    Swal({
      title: 'Imprimare tabel',
      text: text,
      content: container,
      icon: 'warning',
      buttons: ['Anulează', 'Da, continui!'],
      dangerMode: true,
    }).then((willContinue) => {
      if (willContinue) {
        const headerSwitch = document.getElementById('headerSwitch');
        const confidentialSwitch = document.getElementById('confidentialSwitch');
        handlePrint(headerSwitch.checked, confidentialSwitch.checked, dosareFinal);
      }
    });
  };

  const handlePrint = (showHeader1, showConfidential1, dosareFinal) => {
    if (!apiRef2.current) return;
    const orderedFields = apiRef2.current.state.columns.orderedFields;
    const visibleColumns = orderedFields
      .map(field => columns.find(col => col.field === field))
      .filter(col => col && columnVisibilityModel[col.field] !== false);

    if (visibleColumns.length === 0 || dosareFinal.length === 0) return;

    let pageFormat = 'a4';
    if (visibleColumns.length > 5 && visibleColumns.length <= 8) pageFormat = 'a3';
    else if (visibleColumns.length > 8 && visibleColumns.length <= 12) pageFormat = 'a2';
    else if (visibleColumns.length > 12 && visibleColumns.length <= 15) pageFormat = 'a1';
    else if (visibleColumns.length > 15) pageFormat = 'a0';

    const doc = new jsPDF({ orientation: 'landscape', format: pageFormat });
    callAddFont(doc);
    doc.setFont('DejaVuSans');

    let startY2 = 20;
    if (showHeader1) {
      doc.setFontSize(12);
      doc.setTextColor('#333');
      const grupuri = usercurentgrup.split(',');
      const grupuriText = grupuri.length > 1
        ? `pentru ${grupuri.length} unități (${usercurentgrup})`
        : `pentru unitatea ${usercurentgrup}`;
      doc.text(`Raport dosare cu termene generat la ${formattedDate} ora ${formattedTime2}, ${grupuriText}.`, 14, startY2);
      if (startDate) {
        const sd = format(startDate, 'dd.MM.yyyy');
        const ed = endDate ? format(endDate, 'dd.MM.yyyy') : formattedDate;
        doc.text(`Perioada: ${sd} - ${ed} din JuristPRO NEXT ${denAppVers}.`, 14, startY2 + 10);
      } else {
        doc.text(`Exportul a fost realizat pentru toată perioada din JuristPRO NEXT ${denAppVers}.`, 14, startY2 + 10);
      }
      startY2 += 12;
    }

    if (showConfidential1) {
      doc.setFontSize(14);
      doc.setTextColor(255, 0, 0);
      doc.text(`CONFIDENTIAL utilizator ${usercurentnume}`, 14, startY2 + 10);
      startY2 += 10;
    }

    const tableColumnHeaders = visibleColumns.map(col => col.headerName);
    const tableRows = dosareFinal.map((row) =>
      visibleColumns.map((col) => {
        if (col.field === 'datatermen') return formatDateTime(row[col.field]);
        if (col.field === 'datastadiu' || col.field === 'dataDocument') return formatDate(row[col.field]);
        return row[col.field] || '';
      })
    );

    doc.autoTable({
      head: [tableColumnHeaders],
      body: tableRows,
      startY: startY2 + 10,
      theme: 'grid',
      styles: { font: 'DejaVuSans', fontSize: 10, cellPadding: 3, overflow: 'linebreak', cellWidth: 'auto' },
      tableWidth: 'auto',
      didDrawPage: (data) => {
        const pageCount = doc.internal.getNumberOfPages();
        doc.setFontSize(10);
        doc.text(`Pagina ${data.pageNumber} din ${pageCount}`, data.settings.margin.left, doc.internal.pageSize.height - 10);
      },
    });

    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    const printWindow = window.open(pdfUrl);
    if (printWindow) {
      printWindow.addEventListener('load', () => {
        printWindow.print();
      });
    }
  };

  // Prepare data for Excel export - respectă ordinea coloanelor din DataGrid
  const prepareDataForExport = (data, columns, columnVisibilityModel) => {
    // Folosim ordinea coloanelor din DataGrid dacă e disponibilă
    let orderedColumnFields;
    if (apiRef2.current?.state?.columns?.orderedFields) {
      orderedColumnFields = apiRef2.current.state.columns.orderedFields
        .filter(field => columnVisibilityModel[field] !== false && field !== '__check__' && field !== '__detail_panel_toggle__');
    } else {
      orderedColumnFields = columns
        .filter(col => columnVisibilityModel[col.field] !== false && col.field !== '__check__')
        .map(col => col.field);
    }

    const columnInfoMap = columns.reduce((acc, column) => {
      acc[column.field] = column.headerName || column.field;
      return acc;
    }, {});

    return data.map(row => {
      const filteredRow = {};
      orderedColumnFields.forEach(key => {
        let value = row[key] !== undefined ? row[key] : '';
        if (key === 'datatermen') value = formatDateTime(value);
        else if (key === 'datastadiu' || key === 'dataDocument') value = formatDate(value);
        if (typeof value === 'string' && value.includes(',')) {
          value = value.replace(/,/g, ';');
        }
        filteredRow[columnInfoMap[key] || key] = value;
      });
      return filteredRow;
    });
  };

  // Custom pagination cu selector page size explicit
  const CustomPaginationTermene = () => {
    const apiRefPag = useGridApiContext();
    const page = useGridSelector(apiRefPag, (state) => state.pagination.paginationModel.page);
    const pageSize = useGridSelector(apiRefPag, (state) => state.pagination.paginationModel.pageSize);
    const pageCount = useGridSelector(apiRefPag, gridPageCountSelector);
    const totalRowCount = useGridSelector(apiRefPag, gridRowCountSelector);
    const filteredRowCount2 = useGridSelector(apiRefPag, gridFilteredTopLevelRowCountSelector);
    const rowCount = filteredRowCount2 != null ? filteredRowCount2 : totalRowCount;

    const pageOptions = [];
    for (let i = 0; i < pageCount; i++) {
      pageOptions.push(i);
    }

    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%', gap: 2, px: 1, py: 0.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <span style={{ fontSize: '13px', color: '#666' }}>Rânduri pe pagină:</span>
          <Select
            value={pageSize}
            onChange={(e) => apiRefPag.current.setPageSize(Number(e.target.value))}
            size="small"
            sx={{ minWidth: 60, height: 28, fontSize: '13px',
              '& .MuiSelect-select': { paddingTop: '4px', paddingBottom: '4px', paddingLeft: '8px', paddingRight: '24px' },
              '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d0d0d0' },
            }}
          >
            {[10, 20, 30, 50, 100, 250].map((size) => (
              <MenuItem key={size} value={size} sx={{ fontSize: '13px' }}>{size}</MenuItem>
            ))}
          </Select>
        </Box>

        {pageCount > 1 && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <span style={{ fontSize: '13px', color: '#666' }}>Pagina:</span>
            <Select
              value={page}
              onChange={(e) => apiRefPag.current.setPage(Number(e.target.value))}
              size="small"
              sx={{ minWidth: 60, height: 28, fontSize: '13px',
                '& .MuiSelect-select': { paddingTop: '4px', paddingBottom: '4px', paddingLeft: '8px', paddingRight: '24px' },
                '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d0d0d0' },
              }}
              MenuProps={{ PaperProps: { sx: { maxHeight: 300, '& .MuiMenuItem-root': { fontSize: '13px', minHeight: '32px' } } } }}
            >
              {pageOptions.map((p) => (
                <MenuItem key={p} value={p} sx={{ fontSize: '13px' }}>{p + 1}</MenuItem>
              ))}
            </Select>
          </Box>
        )}

        <span style={{ fontSize: '13px', color: '#666' }}>
          {page * pageSize + 1}–{Math.min((page + 1) * pageSize, rowCount)} din {rowCount}
        </span>

        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <IconButton size="small" disabled={page === 0} onClick={() => apiRefPag.current.setPage(page - 1)}>
            <span style={{ fontSize: '18px' }}>‹</span>
          </IconButton>
          <IconButton size="small" disabled={page >= pageCount - 1} onClick={() => apiRefPag.current.setPage(page + 1)}>
            <span style={{ fontSize: '18px' }}>›</span>
          </IconButton>
        </Box>
      </Box>
    );
  };

  const csvOptions = {
    fileName: fileNameCSV,
    delimiter: ',',
    utf8WithBom: true,
  };

  const FlexContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  });

  // Toolbar custom
  const CustomGridToolbarContainer = () => {
    return (
      <>
        <GridToolbarContainer>
          <FlexContainer style={{ paddingBottom: '10px', paddingTop: '5px' }}>
            <Box sx={{ display: 'flex', alignItems: 'left', mr: 1 }}>
              <GridToolbarColumnsButton />
              <GridToolbarFilterButton />
              <GridToolbarDensitySelector />

              <GridToolbarExportContainer>
                <MenuItem onClick={handlePrintComand}>
                  Imprimare tabel
                </MenuItem>
                <MenuItem onClick={handleExportPDFComand}>
                  Export PDF tabel
                </MenuItem>
                <ExportInExcel
                  csvData={prepareDataForExport(expandDosareToTermene(getDosareFinal()), columns, columnVisibilityModel)}
                  fileName={fileNameExcel}
                  showHeader={showHeader}
                  showConfidential={showConfidential}
                  afisamSwal={true}
                  startDate={startDate ? format(startDate, 'dd.MM.yyyy') : ''}
                  dateFilterType={'datatermen'}
                  endDate={endDate ? format(endDate, 'dd.MM.yyyy') : ''}
                />
                <GridCsvExportMenuItem options={csvOptions} />
                <MenuItem onClick={handleExportXML}>
                  În format XML
                </MenuItem>
              </GridToolbarExportContainer>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            </Box>
          </FlexContainer>
        </GridToolbarContainer>
        {isLoading && (
          <div style={{ width: '100%', marginBottom: 8 }}>
            <LinearProgress />
          </div>
        )}
      </>
    );
  };

  // Detail panel - afișare stadii și termene grupate într-un tabel
  const getDetailPanelContent = useCallback(({ row }) => {
    const stadii = row._stadii;
    if (!stadii || stadii.length === 0) return null;

    return (
      <Box sx={{ p: 2, backgroundColor: '#fafbfc', borderLeft: '3px solid #1976d2', width: 'fit-content', minWidth: 600, maxWidth: 950 }}>
        <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 600, fontSize: '13px' }}>
          <GavelIcon style={{ fontSize: 16, marginRight: 4, verticalAlign: 'middle' }} />
          Stadii și termene — {row.numardosarfinal} ({stadii.length} {stadii.length === 1 ? 'stadiu' : 'stadii'})
        </Typography>

        {stadii.map((stadiu, idx) => (
          <Box key={stadiu.id || idx} sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ fontWeight: 600, color: '#1976d2', mb: 0.5, fontSize: '12px' }}>
              {stadiu.denumireStadiu} — {stadiu.instanta}
              {stadiu.sectie && <span style={{ color: '#666', fontWeight: 400 }}> ({stadiu.sectie})</span>}
              {stadiu.data && <span style={{ color: '#888', marginLeft: 8, fontWeight: 400 }}>din {formatDate(stadiu.data)}</span>}
            </Typography>

            {stadiu.termene && stadiu.termene.length > 0 ? (
              <TableContainer component={Paper} variant="outlined" sx={{ ml: 1, maxWidth: 900, width: 'fit-content' }}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                      <TableCell sx={{ fontWeight: 600, fontSize: '11px', py: 0.5 }}>Dată termen</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: '11px', py: 0.5 }}>Complet</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: '11px', py: 0.5 }}>Tip soluție</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: '11px', py: 0.5 }}>Sumar soluție</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: '11px', py: 0.5 }}>Nr. document</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: '11px', py: 0.5 }}>Dată document</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {stadiu.termene.map((termen, tIdx) => {
                      const d = new Date(termen.dataTermen);
                      const isPast = d < new Date();
                      return (
                        <TableRow key={termen.id || tIdx} sx={{ '&:hover': { backgroundColor: '#f0f7ff' } }}>
                          <TableCell sx={{ fontSize: '11px', py: 0.5, color: isPast ? '#d32f2f' : '#2e7d32', fontWeight: 500, whiteSpace: 'nowrap' }}>
                            <EventNoteIcon style={{ fontSize: 13, marginRight: 3, verticalAlign: 'middle' }} />
                            {formatDateTime(termen.dataTermen)}
                          </TableCell>
                          <TableCell sx={{ fontSize: '11px', py: 0.5 }}>{termen.complet || '—'}</TableCell>
                          <TableCell sx={{ fontSize: '11px', py: 0.5 }}>
                            {termen.tipsolutie ? (
                              <Chip label={termen.tipsolutie} size="small" color="primary" variant="outlined" sx={{ height: 20, fontSize: '10px' }} />
                            ) : '—'}
                          </TableCell>
                          <TableCell sx={{ fontSize: '11px', py: 0.5, maxWidth: 250 }}>
                            {termen.sumarsolutie ? (
                              <Tooltip title={termen.sumarsolutie}>
                                <span style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 250 }}>
                                  {termen.sumarsolutie}
                                </span>
                              </Tooltip>
                            ) : '—'}
                          </TableCell>
                          <TableCell sx={{ fontSize: '11px', py: 0.5 }}>{termen.numarDocument || '—'}</TableCell>
                          <TableCell sx={{ fontSize: '11px', py: 0.5 }}>
                            {termen.dataDocument && termen.dataDocument !== '0000-00-00 00:00:00' ? formatDate(termen.dataDocument) : '—'}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography variant="caption" sx={{ ml: 1, color: '#999', fontStyle: 'italic' }}>Fără termene</Typography>
            )}
          </Box>
        ))}
      </Box>
    );
  }, []);

  const getDetailPanelHeight = useCallback(() => 'auto', []);

  // RENDER
  return (
    <div 
      style={{ 
        height: '100%', 
        display: 'flex', 
        flexDirection: 'column', 
        maxWidth: isWide ? '98%' : '',   
        transition: 'max-width 0.3s ease-in-out' 
      }} 
      className="container card p-3 mt-3" 
      id='rapoarteTermene'
    >

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <PageExpander onToggle={handleToggle} />
          <h5 className='p-2 text-uppercase'>
            <EventNoteIcon style={{ fontSize: 20, marginRight: 6 }} />
            Raport dosare cu termene
          </h5>
        </div>
      </div>

      {/* Filtre */}
      <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 1, mt: 1, flexWrap: 'wrap', gap: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ro}>
            <DatePicker
              label="De la"
              value={startDate}
              onChange={(newDate) => setStartDate(newDate)}
              renderInput={(params) => <TextField {...params} size='small' />}
              inputFormat="dd.MM.yyyy"
              format="dd.MM.yyyy"
              className='inputMicMic'
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ro}>
            <DatePicker
              label="Până la"
              value={endDate}
              onChange={(newDate) => setEndDate(newDate)}
              renderInput={(params) => <TextField {...params} size='small' />}
              inputFormat="dd.MM.yyyy"
              format="dd.MM.yyyy"
              className='inputMicMic'
            />
          </LocalizationProvider>

          <Tooltip title="Resetare filtre date">
            <IconButton size="small" onClick={() => { setStartDate(null); setEndDate(null); }}>
              <CancelPresentationIcon />
            </IconButton>
          </Tooltip>

          <FormControl variant="outlined" size="small" sx={{ minWidth: 130 }}>
            <InputLabel style={{ fontSize: '11px' }}>Accesorii</InputLabel>
            <Select
              size='small'
              style={{ fontSize: '11px' }}
              value={accesoriiFiltru}
              onChange={(e) => setAccesoriiFiltru(e.target.value)}
              label="Accesorii"
            >
              <MenuItem value="" style={{ fontSize: '11px' }}>Toate</MenuItem>
              <MenuItem value="1" style={{ fontSize: '11px' }}>Cu accesorii</MenuItem>
              <MenuItem value="0" style={{ fontSize: '11px' }}>Fără accesorii</MenuItem>
            </Select>
          </FormControl>

          <FormControl variant="outlined" size="small" sx={{ minWidth: 140 }}>
            <InputLabel style={{ fontSize: '11px' }}>Monitorizat</InputLabel>
            <Select
              size='small'
              style={{ fontSize: '11px' }}
              value={monitorizatFiltru}
              onChange={(e) => setMonitorizatFiltru(e.target.value)}
              label="Monitorizat"
            >
              <MenuItem value="" style={{ fontSize: '11px' }}>Toate</MenuItem>
              <MenuItem value="1" style={{ fontSize: '11px' }}>Monitorizate</MenuItem>
              <MenuItem value="0" style={{ fontSize: '11px' }}>Nemonitorizate</MenuItem>
            </Select>
          </FormControl>

          <FormControl variant="outlined" size="small" sx={{ minWidth: 140 }}>
            <InputLabel style={{ fontSize: '11px' }}>Sincronizat</InputLabel>
            <Select
              size='small'
              style={{ fontSize: '11px' }}
              value={sincronizatFiltru}
              onChange={(e) => setSincronizatFiltru(e.target.value)}
              label="Sincronizat"
            >
              <MenuItem value="" style={{ fontSize: '11px' }}>Toate</MenuItem>
              <MenuItem value="1" style={{ fontSize: '11px' }}>Sincronizate</MenuItem>
              <MenuItem value="0" style={{ fontSize: '11px' }}>Nesincronizate</MenuItem>
            </Select>
          </FormControl>

          <Button
            variant="outlined"
            size="small"
            onClick={fetchData}
            style={{ fontSize: '11px' }}
          >
            Actualizare
          </Button>
        </Box>
      </Box>

      {/* DataGrid */}
      <div className="allow-page-size-selector" id="rapoarteTermeneGrid">
        <DataGridPro          apiRef={apiRef2}
          rows={dosare}
          columns={columns}
          onStateChange={handleStateChange}
          checkboxSelection
          disableSelectionOnClick={true}
          onRowSelectionModelChange={(newSelection) => setSelectionModel(newSelection)}
          rowSelectionModel={selectionModel}
          onRowClick={handleRowClick}
          onSortModelChange={handleSortModelChange}
          onFilterModelChange={handleFilterModelChange}
          filterModel={filterModel}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[10, 20, 30, 50, 100, 250]}
          pagination
          paginationMode="client"
          density="compact"
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) => setColumnVisibilityModel(newModel)}
          getDetailPanelContent={getDetailPanelContent}
          getDetailPanelHeight={getDetailPanelHeight}
          slots={{
            toolbar: CustomGridToolbarContainer,
            pagination: CustomPaginationTermene,
          }}
          localeText={{
            ...roRO.components.MuiDataGrid.defaultProps.localeText,
            toolbarExport: 'Export',
            toolbarExportLabel: 'Export',
            toolbarExportCSV: 'În format CSV',
            toolbarExportPrint: 'Imprimare tabel',
            filterOperatorContains: 'conține',
            filterOperatorIsAnyOf: 'este una din valorile',
            filterOperatorIsEmpty: 'este necompletat',
            filterOperatorIsNotEmpty: 'este completat',
          }}
          getRowClassName={(params) => {
            const d = new Date(params.row.datatermen);
            const now = new Date();
            if (params.row.datatermen && d < now) return 'termenTrecut';
            return params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd';
          }}
          sx={{
            '& .termenTrecut': {
              backgroundColor: '#fff3f3',
            },
            minHeight: 500,
          }}
          unstable_headerFilters
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', py: 0.5, px: 1 }}>
          <Typography variant="caption" style={{ fontSize: '12px', color: '#666' }}>
            {filteredRowCount !== null
              ? <>Afișate: <strong>{filteredRowCount}</strong> din <strong>{nrTotal}</strong> dosare (filtrate)</>
              : <>Total: <strong>{nrTotal}</strong> dosare</>
            }
          </Typography>
        </Box>
      </div>

      {/* Modal detalii dosar */}
      <Dialog open={openModal} onClose={handleCloseModal} maxWidth="md" fullWidth>
        {selectedRow && (() => {
          const nextTermen = getNextTermen(selectedRow._stadii);
          const allTermene = getAllTermene(selectedRow._stadii);
          const currentIndex = dosare.findIndex(d => d.id === selectedRow.id);
          const hasPrev = currentIndex > 0;
          const hasNext = currentIndex < dosare.length - 1;
          return (<>
            <DialogTitle className='titluModal' sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Tooltip title="Dosarul anterior"><span><IconButton size="small" onClick={() => handleNavigateDosar('prev')} disabled={!hasPrev} sx={{ color: '#fff', opacity: hasPrev ? 1 : 0.3 }}><NavigateBeforeIcon fontSize="small" /></IconButton></span></Tooltip>
                <Tooltip title="Dosarul următor"><span><IconButton size="small" onClick={() => handleNavigateDosar('next')} disabled={!hasNext} sx={{ color: '#fff', opacity: hasNext ? 1 : 0.3 }}><NavigateNextIcon fontSize="small" /></IconButton></span></Tooltip>
                <GavelIcon style={{ fontSize: 18, marginLeft: 4 }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 600, fontSize: '14px', color: '#fff' }}>Dosar {selectedRow.numardosarfinal}</Typography>
                <Tooltip title="Copiază număr dosar"><IconButton size="small" onClick={handleCopyNumarDosar} sx={{ color: '#fff', ml: 0.5 }}><ContentCopyIcon style={{ fontSize: 15 }} /></IconButton></Tooltip>
              </Box>
              <Box>
                <Tooltip title="Vizualizare pe portal.just.ro"><IconButton size="small" onClick={() => window.open(`https://portal.just.ro/SitePages/cautare.aspx?k=${encodeURIComponent(selectedRow.numardosarfinal)}`, '_blank')} sx={{ color: '#fff' }}><OpenInNewIcon fontSize="small" /></IconButton></Tooltip>
                <Tooltip title="Export PDF fișă dosar"><IconButton size="small" onClick={handleExportFisaDosar} sx={{ color: '#fff' }}><PrintIcon fontSize="small" /></IconButton></Tooltip>
                <IconButton size="small" onClick={handleCloseModal} sx={{ color: '#fff' }}><CloseIcon fontSize="small" /></IconButton>
              </Box>
            </DialogTitle>
            <DialogContent sx={{ pt: 2.5, pb: 1 }}>
              {nextTermen && (
                <Box sx={{ mb: 2, p: 1.5, backgroundColor: '#e8f5e9', borderRadius: 1, border: '1px solid #c8e6c9', display: 'flex', alignItems: 'center', gap: 1 }}>
                  <StarIcon style={{ fontSize: 18, color: '#2e7d32' }} />
                  <Box>
                    <Typography variant="caption" sx={{ color: '#2e7d32', fontWeight: 600, fontSize: '10px', textTransform: 'uppercase' }}>Termen următor</Typography>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: '#2e7d32', fontSize: '13px' }}>
                      {formatDateTime(nextTermen.dataTermen)} — {nextTermen.stadiuNume} la {nextTermen.stadiuInstanta}
                      {nextTermen.complet && <span style={{ fontWeight: 400 }}> ({nextTermen.complet})</span>}
                    </Typography>
                  </Box>
                </Box>
              )}
              <Box sx={{ borderRadius: 1, overflow: 'hidden', border: '1px solid #e0e0e0', mb: 2, mt: '10px' }}>
                {[['Client', selectedRow.client, 'Parte adversă', selectedRow.parteadversa],['Instanță', selectedRow.deninstanta, 'Obiect dosar', selectedRow.denumireobiect],['Materie', selectedRow.materie_obiect_dosar, 'Calitate client', selectedRow.calitateclientdosar],['Stare dosar', selectedRow.staredosar, 'Utilizator', selectedRow.user_fullname]].map((row, idx) => (
                  <Box key={idx} sx={{ display: 'flex', backgroundColor: idx % 2 === 0 ? '#fafafa' : '#fff', borderBottom: '1px solid #f0f0f0' }}>
                    <Box sx={{ flex: 1, px: 2, py: 1, borderRight: '1px solid #f0f0f0' }}>
                      <Typography variant="caption" sx={{ color: '#555', fontSize: '10px', textTransform: 'uppercase', letterSpacing: 0.5, fontWeight: 700 }}>{row[0]}</Typography>
                      <Typography variant="body2" sx={{ fontWeight: 500, fontSize: '13px', mt: 0.2 }}>{row[0] === 'Stare dosar' ? (<Chip label={row[1] || '—'} size="small" color={row[1] === 'activ' ? 'success' : row[1] === 'finalizat' ? 'default' : 'primary'} variant="outlined" sx={{ height: 22, fontSize: '11px' }} />) : (row[1] || '—')}</Typography>
                    </Box>
                    <Box sx={{ flex: 1, px: 2, py: 1 }}>
                      <Typography variant="caption" sx={{ color: '#555', fontSize: '10px', textTransform: 'uppercase', letterSpacing: 0.5, fontWeight: 700 }}>{row[2]}</Typography>
                      <Typography variant="body2" sx={{ fontWeight: 500, fontSize: '13px', mt: 0.2 }}>{row[3] || '—'}</Typography>
                    </Box>
                  </Box>
                ))}
                {selectedRow.parti_dosar && (<Box sx={{ px: 2, py: 1, backgroundColor: '#fafafa', borderTop: '1px solid #f0f0f0' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => setPartiExpanded(!partiExpanded)}>
                    {partiExpanded ? <ExpandLessIcon sx={{ fontSize: 16, color: '#555' }} /> : <ExpandMoreIcon sx={{ fontSize: 16, color: '#555' }} />}
                    <Typography variant="caption" sx={{ color: '#555', fontSize: '10px', textTransform: 'uppercase', letterSpacing: 0.5, fontWeight: 700, ml: 0.3 }}>Părți dosar ({selectedRow.parti_dosar.split(',').filter(p => p.trim()).length})</Typography>
                  </Box>
                  <Collapse in={partiExpanded}>
                    <Box sx={{ display: 'flex', gap: 0, mt: 0.5, border: '1px solid #e8e8e8', borderRadius: 0.5, overflow: 'hidden' }}>
                      {(() => {
                        const parti = selectedRow.parti_dosar.split(',').filter(p => p.trim());
                        const half = Math.ceil(parti.length / 2);
                        const col1 = parti.slice(0, half);
                        const col2 = parti.slice(half);
                        return (<>
                          <Box sx={{ flex: 1, borderRight: '1px solid #e8e8e8' }}>
                            {col1.map((parte, idx) => (
                              <Box key={idx} sx={{ px: 1.5, py: 0.5, fontSize: '11px', backgroundColor: idx % 2 === 0 ? '#fff' : '#f5f5f5', borderBottom: '1px solid #f0f0f0', color: '#333' }}>
                                {idx + 1}. {parte.trim()}
                              </Box>
                            ))}
                          </Box>
                          <Box sx={{ flex: 1 }}>
                            {col2.map((parte, idx) => (
                              <Box key={idx} sx={{ px: 1.5, py: 0.5, fontSize: '11px', backgroundColor: idx % 2 === 0 ? '#fff' : '#f5f5f5', borderBottom: '1px solid #f0f0f0', color: '#333' }}>
                                {half + idx + 1}. {parte.trim()}
                              </Box>
                            ))}
                          </Box>
                        </>);
                      })()}
                    </Box>
                  </Collapse>
                </Box>)}
              </Box>
              <Divider sx={{ mb: 2 }} />
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, fontSize: '13px', color: '#333' }}><EventNoteIcon style={{ fontSize: 16, marginRight: 4, verticalAlign: 'middle' }} />Stadii și termene ({selectedRow.nrStadii} {selectedRow.nrStadii === 1 ? 'stadiu' : 'stadii'}, {selectedRow.nrTermene} {selectedRow.nrTermene === 1 ? 'termen' : 'termene'})</Typography>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                  <Tooltip title={showTimeline ? 'Ascunde timeline' : 'Arată timeline cronologic'}><IconButton size="small" onClick={() => setShowTimeline(!showTimeline)} color={showTimeline ? 'primary' : 'default'}><TimelineIcon fontSize="small" /></IconButton></Tooltip>
                  <Tooltip title="Expandează toate"><IconButton size="small" onClick={() => toggleAllStadii(true)}><ExpandMoreIcon fontSize="small" /></IconButton></Tooltip>
                  <Tooltip title="Colapsează toate"><IconButton size="small" onClick={() => toggleAllStadii(false)}><ExpandLessIcon fontSize="small" /></IconButton></Tooltip>
                </Box>
              </Box>
              {showTimeline && allTermene.length > 0 && (
                <Box sx={{ mb: 2, p: 1.5, backgroundColor: '#f8f9fa', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                  <Typography variant="caption" sx={{ fontWeight: 600, fontSize: '10px', textTransform: 'uppercase', color: '#666', mb: 1, display: 'block' }}>Cronologie termene</Typography>
                  <Box sx={{ position: 'relative', pl: 2 }}>
                    <Box sx={{ position: 'absolute', left: 7, top: 0, bottom: 0, width: 2, backgroundColor: '#1976d2', opacity: 0.3 }} />
                    {allTermene.map((t, idx) => { const d = new Date(t.dataTermen); const isPast = d < new Date(); const isNext = nextTermen && t.dataTermen === nextTermen.dataTermen; return (
                      <Box key={idx} sx={{ display: 'flex', alignItems: 'flex-start', mb: 1, position: 'relative' }}>
                        <Box sx={{ position: 'absolute', left: -17, top: 4, width: isNext ? 12 : 8, height: isNext ? 12 : 8, borderRadius: '50%', backgroundColor: isNext ? '#2e7d32' : isPast ? '#d32f2f' : '#1976d2', border: isNext ? '2px solid #a5d6a7' : 'none' }} />
                        <Box sx={{ ml: 1 }}><Typography variant="body2" sx={{ fontSize: '11px', fontWeight: isNext ? 700 : 400, color: isNext ? '#2e7d32' : isPast ? '#999' : '#333', textDecoration: isPast && !isNext ? 'line-through' : 'none' }}>
                          {formatDateTime(t.dataTermen)}<span style={{ color: '#1976d2', marginLeft: 6, fontWeight: 400, textDecoration: 'none' }}>{t.stadiuNume}</span>{t.complet && <span style={{ color: '#888', marginLeft: 4, textDecoration: 'none' }}>({t.complet})</span>}{t.tipsolutie && <span style={{ color: '#666', marginLeft: 4, textDecoration: 'none' }}>— {t.tipsolutie}</span>}{isNext && <Chip label="URMĂTOR" size="small" color="success" sx={{ ml: 1, height: 16, fontSize: '9px' }} />}
                        </Typography></Box>
                      </Box>); })}
                  </Box>
                </Box>
              )}
              {selectedRow._stadii && selectedRow._stadii.length > 0 ? (selectedRow._stadii.map((stadiu, idx) => { const stadiuKey = stadiu.id || idx; const isExpanded = expandedStadii[stadiuKey] !== false; return (
                <Box key={stadiuKey} sx={{ mb: 2, pl: 1, borderLeft: '3px solid #1976d2' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', '&:hover': { backgroundColor: '#f5f8ff' }, borderRadius: 0.5, py: 0.3 }} onClick={() => toggleStadiu(stadiuKey)}>
                    {isExpanded ? <ExpandLessIcon sx={{ fontSize: 18, color: '#1976d2' }} /> : <ExpandMoreIcon sx={{ fontSize: 18, color: '#1976d2' }} />}
                    <Typography variant="body2" sx={{ fontWeight: 600, color: '#1976d2', fontSize: '12px', ml: 0.5 }}>{stadiu.denumireStadiu} — {stadiu.instanta}{stadiu.sectie && <span style={{ color: '#666', fontWeight: 400 }}> ({stadiu.sectie})</span>}{stadiu.data && <span style={{ color: '#888', marginLeft: 8, fontWeight: 400 }}>din {formatDate(stadiu.data)}</span>}<span style={{ color: '#999', marginLeft: 8, fontWeight: 400 }}>({(stadiu.termene || []).length} termene)</span></Typography>
                  </Box>
                  <Collapse in={isExpanded}>
                    {stadiu.termene && stadiu.termene.length > 0 ? (
                      <TableContainer component={Paper} variant="outlined" sx={{ mt: 0.5, maxWidth: '100%' }}><Table size="small"><TableHead><TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell sx={{ fontWeight: 600, fontSize: '11px', py: 0.5 }}>Dată termen</TableCell><TableCell sx={{ fontWeight: 600, fontSize: '11px', py: 0.5 }}>Complet</TableCell><TableCell sx={{ fontWeight: 600, fontSize: '11px', py: 0.5 }}>Tip soluție</TableCell><TableCell sx={{ fontWeight: 600, fontSize: '11px', py: 0.5 }}>Sumar soluție</TableCell><TableCell sx={{ fontWeight: 600, fontSize: '11px', py: 0.5 }}>Nr. document</TableCell><TableCell sx={{ fontWeight: 600, fontSize: '11px', py: 0.5 }}>Dată document</TableCell>
                      </TableRow></TableHead><TableBody>
                        {stadiu.termene.map((termen, tIdx) => { const d = new Date(termen.dataTermen); const isPast = d < new Date(); const isNextT = nextTermen && termen.dataTermen === nextTermen.dataTermen; return (
                          <TableRow key={termen.id || tIdx} sx={{ backgroundColor: isNextT ? '#e8f5e9' : tIdx % 2 === 0 ? '#fff' : '#fafafa', '&:hover': { backgroundColor: isNextT ? '#c8e6c9' : '#f0f7ff' } }}>
                            <TableCell sx={{ fontSize: '11px', py: 0.7, color: isPast ? '#d32f2f' : '#2e7d32', fontWeight: isNextT ? 700 : 500, whiteSpace: 'nowrap' }}><EventNoteIcon style={{ fontSize: 13, marginRight: 3, verticalAlign: 'middle' }} />{formatDateTime(termen.dataTermen)}{isNextT && <Chip label="URMĂTOR" size="small" color="success" sx={{ ml: 0.5, height: 16, fontSize: '9px' }} />}</TableCell>
                            <TableCell sx={{ fontSize: '11px', py: 0.7 }}>{termen.complet || '—'}</TableCell>
                            <TableCell sx={{ fontSize: '11px', py: 0.7 }}>{termen.tipsolutie ? <Chip label={termen.tipsolutie} size="small" color="primary" variant="outlined" sx={{ height: 20, fontSize: '10px' }} /> : '—'}</TableCell>
                            <TableCell sx={{ fontSize: '11px', py: 0.7, maxWidth: 280 }}>{termen.sumarsolutie ? (<Tooltip title={termen.sumarsolutie}><span style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 280 }}>{termen.sumarsolutie}</span></Tooltip>) : '—'}</TableCell>
                            <TableCell sx={{ fontSize: '11px', py: 0.7 }}>{termen.numarDocument || '—'}</TableCell>
                            <TableCell sx={{ fontSize: '11px', py: 0.7 }}>{termen.dataDocument && termen.dataDocument !== '0000-00-00 00:00:00' ? formatDate(termen.dataDocument) : '—'}</TableCell>
                          </TableRow>); })}
                      </TableBody></Table></TableContainer>
                    ) : (<Typography variant="caption" sx={{ color: '#999', fontStyle: 'italic', ml: 3, display: 'block', mt: 0.5 }}>Fără termene</Typography>)}
                  </Collapse>
                </Box>); }))
              : (<Typography variant="body2" sx={{ color: '#999', fontStyle: 'italic' }}>Fără stadii</Typography>)}
            </DialogContent>
            <DialogActions sx={{ px: 2, py: 1.5, borderTop: '1px solid #e0e0e0', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', gap: 1 }}><Button size="small" startIcon={<PrintIcon />} onClick={handleExportFisaDosar} variant="outlined">Export PDF</Button></Box>
              <Box sx={{ display: 'flex', gap: 1 }}><Button size="small" onClick={() => window.location.href = `editare-dosar/${selectedRow.idDosar}`}>Editare dosar</Button><Button size="small" onClick={handleCloseModal}>Închidere</Button></Box>
            </DialogActions>
          </>); })()}
      </Dialog>
      <Snackbar open={snackbarOpen} autoHideDuration={2000} onClose={() => setSnackbarOpen(false)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}><Alert onClose={() => setSnackbarOpen(false)} severity="success" sx={{ width: '100%' }} variant="filled">{snackbarMessage}</Alert></Snackbar>
    </div>
  );
}

export default RapoarteTermene;
